const tiers = [
    {
        tier: 1,
        start: 0,
        end: 500000,
        descr: "$0 - 500,000",
        cost: 500,
        costStr: "$500",
        planId: "price_1H8zRsBHnOim7SiPAzs8fLag",
        testPlanId: "price_1H8zabBHnOim7SiPC6te592L",
    },
    {
        tier: 2,
        start: 500000,
        end: 1000000,
        descr: "$500,000 - 1,000,000",
        cost: 1000,
        costStr: "$1,000",
        planId: "plan_G7NhsHeygR4RyZ",
        testPlanId: "plan_G7bKcaYos2it45",
    },
    {
        tier: 3,
        start: 1000000,
        end: 1500000,
        descr: "$1,000,000 - 1,500,000",
        cost: 1500,
        costStr: "$1,500",
        planId: "price_1HCVJiBHnOim7SiPpeWLtEQc",
        testPlanId: "price_1HBr98BHnOim7SiPwVZhn5Vv",
    },
    {
        tier: 4,
        start: 1500000,
        end: 2000000,
        descr: "$1,500,000 - 2,000,000",
        cost: 2000,
        costStr: "$2,000",
        planId: "price_1HCVK1BHnOim7SiPnk4zyuau",
        testPlanId: "price_1HBr9OBHnOim7SiPMQIePQnq",
    },
    {
        tier: 5,
        start: 2000000,
        end: 2500000,
        descr: "$2,000,000 - 2,500,000",
        cost: 2500,
        costStr: "$2,500",
        planId: "price_1HCVKABHnOim7SiPCyKacUgF",
        testPlanId: "price_1HBr9bBHnOim7SiP2NRKv9so",
    },
    {
        tier: 6,
        start: 2500000,
        end: null,
        descr: "$2,500,000 and above",
        cost: 3000,
        costStr: "$3,000",
        planId: "price_1HCVKJBHnOim7SiPxMzxvy0X",
        testPlanId: "price_1HBr9lBHnOim7SiP7iQqUui9",
    },

]



export {
    tiers
}

















